<template>
  <el-dialog :title="isShare?'Share':'Notifications'" :width="dialogWidth" :visible="visible" :close-on-click-modal="false" @close="visible = false">
    <el-form ref="form" :model="ruleForm" :rules="rules" label-position="top" v-loading="form_loading" label-width="150px">
      <el-form-item label="Patient Name" prop="patientName" v-if="!isAdd">
        <div style="display: flex;">
          <el-input v-model="ruleForm.patientName" placeholder="Patient Name"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="Email" prop="sharedEmail">
        <div style="display: flex;">
          <el-checkbox v-model="emailCheck" style="margin-right: 10px;"></el-checkbox>
          <el-input v-model="ruleForm.sharedEmail" :disabled="!emailCheck" placeholder="Patient Email"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="Phone Number" prop="sharedPhoneNumber">
        <div style="display: flex;">
          <el-checkbox v-model="phoneCheck" style="margin-right: 10px;"></el-checkbox>
          <el-input v-model="ruleForm.sharedPhoneNumber" :disabled="!phoneCheck" placeholder="Patient Phone Number" @change="change_phone">
            <template slot="prepend">+1</template>
          </el-input>
        </div>
      </el-form-item>
      <el-form-item style="display: flex;justify-content: center;">
        <el-button type="primary" :disabled="!emailCheck && !phoneCheck" style="background-color: #034844;border-color:#034844;" @click="submitForm">Send</el-button>
        <el-button @click="visible = false">Cancel</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import Vue from 'vue';
import moment from 'moment/moment';
import { postAction,getAction } from '@/network/manage';
export default {
  name: 'Share',
  components: {},
  data() {
    return {
      dialogWidth:'600px',
      id: '',
      isAdd:false,
      emailCheck:true,
      phoneCheck:true,
      visible:false,
      isShare:false,
      ruleForm:{},
      newImage:'',
      rules: {
        patientName:[{ required: true, message: 'Patient Name is required',trigger: 'blur'},],
        sharedPhoneNumber:[
          {
            validator: (rules, value, callback) => {
              if(!value && this.phoneCheck)
                callback(new Error('Phone Number is required'))
              else
                callback()
            },trigger: 'blur'
          }
        ],
        sharedEmail: [
          {
            validator: (rules, value, callback) => {
              const emailFormat = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
              if(!value && this.emailCheck)
                callback(new Error('Email is required'))
              else if(!emailFormat.test(value) && this.emailCheck)
                callback(new Error('Email format incorrect'))
              else
                callback()
            },trigger: 'blur'
          }
        ],
      },
      form_loading: false,
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  computed: {

  },
  created() {
    this.setDialogWidth()
  },
  methods: {
    moment,
    change_phone() {
      if(!this.ruleForm.sharedPhoneNumber) {
        return;
      }
      let phone = this.ruleForm.sharedPhoneNumber.replaceAll("-", "").replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replace(/[^0-9]/g, '')
      if(phone.length != 10) {
        this.$message({
          message: 'Please enter the correct phone number.',
          type: 'warning'
        });
        this.ruleForm.sharedPhoneNumber = ""
        return;
      }
      phone = "+1" + phone
      this.ruleForm.sharedPhoneNumber = "(" + phone.substring(2,5) + ") " + phone.substring(5,8) + " - " + phone.substring(8);
    },
    initShare(id){
      this.isShare = true
      this.init(id)
    },
    initAdd(id){
      this.isAdd = true
      this.init(id)
    },
    init(id) {
      this.visible = true
      this.form_loading = true
      getAction('/admin/caseHistory/queryById?id='+id).then((res) => {
        if(res.success){
          this.ruleForm = res.result
          if(this.ruleForm.sharedPhoneNumber) {
            let phone = this.ruleForm.sharedPhoneNumber
            this.ruleForm.sharedPhoneNumber = "(" + phone.substring(2,5) + ") " + phone.substring(5,8) + " - " + phone.substring(8);
          }
          if(this.ruleForm.firstName){
            this.$set(this.ruleForm,'patientName',this.ruleForm.firstName+' '+this.ruleForm.lastName)
          }
        }else{
          this.$message.error(res.message)
        }
      }).catch((err) => {
        this.$message.error(err.message)
      }).finally((res) => {
        this.form_loading = false
      });
    },
    submitForm() {
      const that = this
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.form_loading = true
          const params = {
            id:that.ruleForm.id,
            patientName:that.ruleForm.patientName
          }
          if(this.emailCheck)
            params.sharedEmail = that.ruleForm.sharedEmail
          if(this.phoneCheck)
            params.sharedPhoneNumber = "+1" + that.ruleForm.sharedPhoneNumber.replaceAll(" ", "").replaceAll("-", "").replaceAll("(", "").replaceAll(")", "")
          if(this.isShare)
            params.shared = 'show'
          postAction('/admin/caseHistory/shareSave',params).then((res) => {
            if(res.success){
              that.$message({
                message: 'share success!',
                type: 'success'
              });
              that.visible = false
              that.$emit('ok')
            }else{
              that.$message.error(res.message)
            }
          }).catch((err) => {
            that.$message.error(err.message)
          }).finally((res) => {
            that.form_loading = false
          });
        }
      });
    },
    setDialogWidth() {
      var val = document.body.clientWidth
      const def = 600 // default width
      if (val < def) {
        this.dialogWidth = '100%'
      } else {
        this.dialogWidth = def + 'px'
      }
    }
  }
}
</script>

<style scoped>
  .form{display: grid;grid-template-columns:1fr 1fr;}
  .form .flex{display: flex;justify-content: space-between;min-height:60px;align-items: center;font-size: 14px;}
  .border{border-bottom: 1px solid #EDF2F7;}
  .left{border-right: 1px solid #EDF2F7;padding-right:30px;margin-right: 30px;}
  .form a{font-size: 18px;font-weight: bold;color: #5856D6;width: 100%;text-align: center;}
  >>>.el-form-item__label{line-height: 1;}
  >>>.el-dialog__header{border-bottom:1px solid #dddddd;padding:15px 20px;}
  >>>.el-dialog__body{padding:20px;}
  h1{font-size: 18px;margin:20px 0;}
  b{font-size: 18px;}
  p{font-size: 14px;}
  .label{display:flex;}
  .label span{margin:0 10px 10px 0;}
  @media (max-width: 768px) {
     .form{display: grid;grid-template-columns:1fr;}
     .left{border-right: 0px solid #EDF2F7;padding-right:0;margin-right: 0;}
  }
</style>
